import apiCommonCategory from "@/api/common-category";
import {post} from "@/utils/request";

export default class apiUserMsg extends apiCommonCategory{
  static module = 'user_msg'

  static async setRead(id=0, isAll=0){
    return post('/home/user_msg/setRead', {id, isAll})
  }

  static async listDel(ids){
    return post('/home/user_msg/listDel', {ids})
  }
}
